import { render, staticRenderFns } from "./PrfCustomerTemplateVariant.vue?vue&type=template&id=3f898a51&scoped=true"
import script from "./PrfCustomerTemplateVariant.vue?vue&type=script&lang=js"
export * from "./PrfCustomerTemplateVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f898a51",
  null
  
)

export default component.exports